import { useEffect } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { UDS_GET_INCENTIVES_REQUEST, debugWallet, UDS_GET_INCENTIVES_COMPLETED } from 'wallet-manager';
import { getIncentives } from 'reaxl-wallet';

/**
 * Hook that handles external incentives requests via event bus. Fetches incentives data when
 * `UDS_GET_INCENTIVES_REQUEST` is received, then emits `UDS_GET_INCENTIVES_COMPLETED` with the results.
 *
 * @param {string} activeTab - Current active deal type
 * @param {Object} incentivesParams - The parameters required for incentives request
 * @param {string} incentivesParams.dealerId - Dealer ID
 * @param {string} incentivesParams.partnerId - Partner ID ('MMD', etc.)
 * @param {string} incentivesParams.listingType - Type of listing ('new', 'used')
 * @param {string} incentivesParams.vin - Vehicle identification number
 * @param {string} incentivesParams.zip - ZIP code
 * @param {Function} incentivesFetcher - Function to fetch incentives data
 * @returns {void}
 */
const useExternalIncentivesRequest = (activeTab, incentivesParams, incentivesFetcher) => {
  const {
    dealerId,
    partnerId,
    listingType = '',
    vin,
    zip
  } = incentivesParams;
  useEffect(() => {
    const handleIncentivesRequest = async () => {
      const params = {
        dealerId,
        dealType: activeTab,
        // optional
        listingType: listingType && listingType[0].toUpperCase() + listingType.slice(1),
        // should be capitalized already, this is just in case,
        partnerId,
        vin,
        zip
      };
      const incentivesUrl = new URLSearchParams(params).toString();
      const incentivesData = await getIncentives({
        incentivesFetcher,
        incentivesUrl
      });
      debugWallet('UDS', 'getIncentives:completed', incentivesData);
      eventBus.emit(UDS_GET_INCENTIVES_COMPLETED, incentivesData);
    };
    eventBus.on(UDS_GET_INCENTIVES_REQUEST, handleIncentivesRequest);
    return () => eventBus.off(UDS_GET_INCENTIVES_REQUEST, handleIncentivesRequest);
  }, [dealerId, incentivesParams, partnerId, listingType, vin, zip, activeTab, incentivesFetcher]);
};
export { useExternalIncentivesRequest as default };
